var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pw-text-overflow"},[_c('div',{ref:"text",staticClass:"text"},[_vm._t("default")],2),(_vm.isOverflowing)?_c('span',{staticClass:"tooltip-text",class:_vm.classes},[_vm._v(" "+_vm._s(_vm.tooltipText)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }